import { Dropzone, Field, useTitle } from "modules/common";
import { useUploadBloomCalendar } from "modules/beekeeping";
import React from "react";
import { Accept } from "react-dropzone/.";

const ACCEPTED_FILES: Accept = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"],
};

export const Beekeeping: React.FC = () => {
    useTitle("Moje pčelarstvo - eSavjetnik");

    const mutateAsync = useUploadBloomCalendar();

    return (
        <div className="beekeeping-container">
            <div className="header-filter-container">
                <div className="header-filter">
                    <span className="beekeeping-header-text">Moje pčelarstvo</span>
                </div>
            </div>
            <Field name="DODAJ KALENDAR">
                <Dropzone
                    handleDrop={(files: File[]) => mutateAsync.mutateAsync(files[0])}
                    accept={ACCEPTED_FILES}
                    vertical={true}
                    clearOnDrop={true}
                    files={[]}
                ></Dropzone>
            </Field>
        </div>
    );
};
